export const userDevice = state => state.userDevice;

export const isAndroidApp = state => state.platformType === 'DOWNLOAD';

/** Returns only 12 or 13. If 12 is returned it is one of the <=12 versions, otherwise >=13 */
export const IOSDeviceVersion = state => state.IOSDeviceVersion;

export const isIPhone = state => state.isIPhone;
